/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const feed = /* GraphQL */ `
  query Feed($limit: Int, $nextToken: String) {
    feed(limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        postID
        postOwnerID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const trendingPosts = /* GraphQL */ `
  query TrendingPosts($limit: Int, $nextToken: String) {
    trendingPosts(limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPostsByAuthor = /* GraphQL */ `
  query ListPostsByAuthor($authorID: ID!, $limit: Int, $nextToken: String) {
    listPostsByAuthor(
      authorID: $authorID
      limit: $limit
      nextToken: $nextToken
    ) {
      id
      type
      authorID
      authorIdentityId
      content
      images
      video
      links
      hashtags
      visibility
      likesCount
      commentsCount
      sharesCount
      isReshare
      originalPostID
      reshareMessage
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      comments {
        nextToken
        __typename
      }
      likes {
        nextToken
        __typename
      }
      feedItems {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      shares {
        nextToken
        __typename
      }
      bookmarks {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listCommentsByPost = /* GraphQL */ `
  query ListCommentsByPost($postID: ID!, $limit: Int, $nextToken: String) {
    listCommentsByPost(postID: $postID, limit: $limit, nextToken: $nextToken) {
      id
      postID
      authorID
      content
      parentID
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const getUserNewsBookmarks = /* GraphQL */ `
  query GetUserNewsBookmarks($limit: Int, $nextToken: String) {
    getUserNewsBookmarks(limit: $limit, nextToken: $nextToken) {
      id
      userID
      newsID
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      news {
        id
        title
        description
        content
        source
        source_url
        author
        published_at
        featured_image
        tmdb_id
        media_type
        category
        tags
        status
        is_featured
        is_breaking
        created_by
        view_count
        bookmark_count
        share_count
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const getBlockedUsers = /* GraphQL */ `
  query GetBlockedUsers($limit: Int, $nextToken: String) {
    getBlockedUsers(limit: $limit, nextToken: $nextToken) {
      success
      blockedUsers {
        id
        blockerID
        blockedID
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      message
      __typename
    }
  }
`;
export const getUserReports = /* GraphQL */ `
  query GetUserReports($limit: Int, $nextToken: String) {
    getUserReports(limit: $limit, nextToken: $nextToken) {
      id
      reporterID
      reportedUserID
      messageID
      reason
      description
      category
      status
      adminNotes
      reviewedBy
      reviewedAt
      createdAt
      updatedAt
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      reportedUser {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      message {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const getMutedUsers = /* GraphQL */ `
  query GetMutedUsers($limit: Int, $nextToken: String) {
    getMutedUsers(limit: $limit, nextToken: $nextToken) {
      id
      muterID
      mutedUserID
      duration
      expiresAt
      reason
      createdAt
      updatedAt
      muter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      mutedUser {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const getUserPostsSecure = /* GraphQL */ `
  query GetUserPostsSecure($authorID: ID!, $limit: Int, $nextToken: String) {
    getUserPostsSecure(
      authorID: $authorID
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserPresence = /* GraphQL */ `
  query GetUserPresence($id: ID!) {
    getUserPresence(id: $id) {
      id
      userID
      status
      lastSeen
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserPresences = /* GraphQL */ `
  query ListUserPresences(
    $filter: ModelUserPresenceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserPresences(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        status
        lastSeen
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFollow = /* GraphQL */ `
  query GetFollow($id: ID!) {
    getFollow(id: $id) {
      id
      followerID
      followeeID
      createdAt
      followee {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listFollows = /* GraphQL */ `
  query ListFollows(
    $id: ID
    $filter: ModelFollowFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listFollows(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        followerID
        followeeID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPost = /* GraphQL */ `
  query GetPost($id: ID!) {
    getPost(id: $id) {
      id
      type
      authorID
      authorIdentityId
      content
      images
      video
      links
      hashtags
      visibility
      likesCount
      commentsCount
      sharesCount
      isReshare
      originalPostID
      reshareMessage
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      comments {
        nextToken
        __typename
      }
      likes {
        nextToken
        __typename
      }
      feedItems {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      shares {
        nextToken
        __typename
      }
      bookmarks {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listPosts = /* GraphQL */ `
  query ListPosts(
    $id: ID
    $filter: ModelPostFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPosts(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getComment = /* GraphQL */ `
  query GetComment($id: ID!, $createdAt: AWSDateTime!) {
    getComment(id: $id, createdAt: $createdAt) {
      id
      postID
      authorID
      content
      parentID
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listComments = /* GraphQL */ `
  query ListComments(
    $id: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listComments(
      id: $id
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        postID
        authorID
        content
        parentID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLike = /* GraphQL */ `
  query GetLike($id: ID!) {
    getLike(id: $id) {
      id
      postID
      userID
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listLikes = /* GraphQL */ `
  query ListLikes(
    $id: ID
    $filter: ModelLikeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLikes(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        postID
        userID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getShare = /* GraphQL */ `
  query GetShare($id: ID!) {
    getShare(id: $id) {
      id
      postID
      userID
      message
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listShares = /* GraphQL */ `
  query ListShares(
    $id: ID
    $filter: ModelShareFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listShares(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        postID
        userID
        message
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFeedItem = /* GraphQL */ `
  query GetFeedItem($id: ID!) {
    getFeedItem(id: $id) {
      id
      userID
      postID
      postOwnerID
      createdAt
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listFeedItems = /* GraphQL */ `
  query ListFeedItems(
    $id: ID
    $filter: ModelFeedItemFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listFeedItems(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        postID
        postOwnerID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserWatchlist = /* GraphQL */ `
  query GetUserWatchlist($id: ID!) {
    getUserWatchlist(id: $id) {
      id
      userID
      name
      description
      isDefault
      isPublic
      itemCount
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      items {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listUserWatchlists = /* GraphQL */ `
  query ListUserWatchlists(
    $id: ID
    $filter: ModelUserWatchlistFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserWatchlists(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        name
        description
        isDefault
        isPublic
        itemCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getWatchlistItem = /* GraphQL */ `
  query GetWatchlistItem($id: ID!) {
    getWatchlistItem(id: $id) {
      id
      userID
      watchlistID
      movieID
      showID
      contentType
      status
      priority
      notes
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      watchlist {
        id
        userID
        name
        description
        isDefault
        isPublic
        itemCount
        createdAt
        updatedAt
        __typename
      }
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      show {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listWatchlistItems = /* GraphQL */ `
  query ListWatchlistItems(
    $id: ID
    $filter: ModelWatchlistItemFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listWatchlistItems(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        watchlistID
        movieID
        showID
        contentType
        status
        priority
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getWatchedItem = /* GraphQL */ `
  query GetWatchedItem($id: ID!, $createdAt: AWSDateTime!) {
    getWatchedItem(id: $id, createdAt: $createdAt) {
      id
      userID
      movieID
      status
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listWatchedItems = /* GraphQL */ `
  query ListWatchedItems(
    $id: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelWatchedItemFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listWatchedItems(
      id: $id
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        movieID
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserMovieInteraction = /* GraphQL */ `
  query GetUserMovieInteraction($id: ID!) {
    getUserMovieInteraction(id: $id) {
      id
      userID
      movieID
      watched
      notInterested
      inWatchlist
      isFavorite
      watchCount
      lastWatchedAt
      userRating
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listUserMovieInteractions = /* GraphQL */ `
  query ListUserMovieInteractions(
    $id: ID
    $filter: ModelUserMovieInteractionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserMovieInteractions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        movieID
        watched
        notInterested
        inWatchlist
        isFavorite
        watchCount
        lastWatchedAt
        userRating
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserShowInteraction = /* GraphQL */ `
  query GetUserShowInteraction($id: ID!) {
    getUserShowInteraction(id: $id) {
      id
      userID
      showID
      watched
      notInterested
      inWatchlist
      isFavorite
      watchCount
      lastWatchedAt
      userRating
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      show {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listUserShowInteractions = /* GraphQL */ `
  query ListUserShowInteractions(
    $id: ID
    $filter: ModelUserShowInteractionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserShowInteractions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        showID
        watched
        notInterested
        inWatchlist
        isFavorite
        watchCount
        lastWatchedAt
        userRating
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNotification = /* GraphQL */ `
  query GetNotification($id: ID!, $createdAt: AWSDateTime!) {
    getNotification(id: $id, createdAt: $createdAt) {
      id
      userID
      type
      message
      isRead
      metadata
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications(
    $id: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listNotifications(
      id: $id
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        type
        message
        isRead
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getConversation = /* GraphQL */ `
  query GetConversation($id: ID!) {
    getConversation(id: $id) {
      id
      user1ID
      user2ID
      isGroup
      groupName
      groupDescription
      groupAvatar
      createdBy
      lastMessageID
      lastMessageText
      lastMessageAt
      user1UnreadCount
      user2UnreadCount
      user1Archived
      user2Archived
      user1ArchivedAt
      user2ArchivedAt
      autoLockEnabled
      lockDuration
      lockedAt
      createdAt
      updatedAt
      user1 {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      user2 {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      creator {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      messages {
        nextToken
        __typename
      }
      participants {
        nextToken
        __typename
      }
      invitations {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listConversations = /* GraphQL */ `
  query ListConversations(
    $id: ID
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listConversations(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGroupParticipant = /* GraphQL */ `
  query GetGroupParticipant($id: ID!) {
    getGroupParticipant(id: $id) {
      id
      conversationID
      userID
      role
      joinedAt
      leftAt
      unreadCount
      archived
      archivedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGroupParticipants = /* GraphQL */ `
  query ListGroupParticipants(
    $id: ID
    $filter: ModelGroupParticipantFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listGroupParticipants(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        conversationID
        userID
        role
        joinedAt
        leftAt
        unreadCount
        archived
        archivedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGroupInvitation = /* GraphQL */ `
  query GetGroupInvitation($id: ID!) {
    getGroupInvitation(id: $id) {
      id
      conversationID
      invitedUserID
      invitedBy
      status
      createdAt
      updatedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      invitedUser {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      inviter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listGroupInvitations = /* GraphQL */ `
  query ListGroupInvitations(
    $id: ID
    $filter: ModelGroupInvitationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listGroupInvitations(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        conversationID
        invitedUserID
        invitedBy
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getReviewReport = /* GraphQL */ `
  query GetReviewReport($id: ID!) {
    getReviewReport(id: $id) {
      id
      reviewID
      reviewType
      reportedBy
      reason
      description
      status
      createdAt
      updatedAt
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listReviewReports = /* GraphQL */ `
  query ListReviewReports(
    $id: ID
    $filter: ModelReviewReportFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listReviewReports(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        reviewID
        reviewType
        reportedBy
        reason
        description
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPostReport = /* GraphQL */ `
  query GetPostReport($id: ID!) {
    getPostReport(id: $id) {
      id
      postID
      reportedBy
      reason
      description
      status
      createdAt
      updatedAt
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listPostReports = /* GraphQL */ `
  query ListPostReports(
    $id: ID
    $filter: ModelPostReportFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPostReports(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        postID
        reportedBy
        reason
        description
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMovieReport = /* GraphQL */ `
  query GetMovieReport($id: ID!) {
    getMovieReport(id: $id) {
      id
      movieID
      reportedBy
      reason
      description
      status
      createdAt
      updatedAt
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listMovieReports = /* GraphQL */ `
  query ListMovieReports(
    $id: ID
    $filter: ModelMovieReportFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMovieReports(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        movieID
        reportedBy
        reason
        description
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getShowReport = /* GraphQL */ `
  query GetShowReport($id: ID!) {
    getShowReport(id: $id) {
      id
      showID
      reportedBy
      reason
      description
      status
      createdAt
      updatedAt
      show {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listShowReports = /* GraphQL */ `
  query ListShowReports(
    $id: ID
    $filter: ModelShowReportFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listShowReports(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        showID
        reportedBy
        reason
        description
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMessage = /* GraphQL */ `
  query GetMessage($id: ID!) {
    getMessage(id: $id) {
      id
      conversationID
      senderID
      receiverID
      content
      messageType
      isRead
      replyToMessageId
      reactions
      createdAt
      updatedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      sender {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      receiver {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      replyToMessage {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      replies {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listMessages = /* GraphQL */ `
  query ListMessages(
    $id: ID
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMessages(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCheatLog = /* GraphQL */ `
  query GetCheatLog($id: ID!) {
    getCheatLog(id: $id) {
      id
      type
      adminUserID
      reason
      metadata
      affectedUserID
      timestamp
      ipAddress
      userAgent
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCheatLogs = /* GraphQL */ `
  query ListCheatLogs(
    $id: ID
    $filter: ModelCheatLogFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCheatLogs(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        type
        adminUserID
        reason
        metadata
        affectedUserID
        timestamp
        ipAddress
        userAgent
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGlobalBoostConfig = /* GraphQL */ `
  query GetGlobalBoostConfig($id: ID!) {
    getGlobalBoostConfig(id: $id) {
      id
      active
      multiplier
      activatedAt
      deactivatedAt
      adminUserID
      reason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listGlobalBoostConfigs = /* GraphQL */ `
  query ListGlobalBoostConfigs(
    $id: ID
    $filter: ModelGlobalBoostConfigFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listGlobalBoostConfigs(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        active
        multiplier
        activatedAt
        deactivatedAt
        adminUserID
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserProgressBoost = /* GraphQL */ `
  query GetUserProgressBoost($id: ID!) {
    getUserProgressBoost(id: $id) {
      id
      userID
      multiplier
      expiresAt
      adminUserID
      reason
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listUserProgressBoosts = /* GraphQL */ `
  query ListUserProgressBoosts(
    $id: ID
    $filter: ModelUserProgressBoostFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserProgressBoosts(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        multiplier
        expiresAt
        adminUserID
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAchievementDefinition = /* GraphQL */ `
  query GetAchievementDefinition($id: ID!) {
    getAchievementDefinition(id: $id) {
      id
      type
      name
      description
      category
      rarity
      points
      icon
      conditions
      conditionType
      targetValue
      targetField
      contentIds
      genreName
      franchiseId
      isActive
      isRepeatable
      maxProgress
      threshold
      badgeType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAchievementDefinitions = /* GraphQL */ `
  query ListAchievementDefinitions(
    $id: ID
    $filter: ModelAchievementDefinitionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAchievementDefinitions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        type
        name
        description
        category
        rarity
        points
        icon
        conditions
        conditionType
        targetValue
        targetField
        contentIds
        genreName
        franchiseId
        isActive
        isRepeatable
        maxProgress
        threshold
        badgeType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBadgeDefinition = /* GraphQL */ `
  query GetBadgeDefinition($id: ID!) {
    getBadgeDefinition(id: $id) {
      id
      type
      name
      description
      icon
      color
      rarity
      points
      isActive
      autoAssign
      conditions
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBadgeDefinitions = /* GraphQL */ `
  query ListBadgeDefinitions(
    $id: ID
    $filter: ModelBadgeDefinitionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listBadgeDefinitions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        type
        name
        description
        icon
        color
        rarity
        points
        isActive
        autoAssign
        conditions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTitleDefinition = /* GraphQL */ `
  query GetTitleDefinition($id: ID!) {
    getTitleDefinition(id: $id) {
      id
      type
      name
      description
      color
      rarity
      minAchievements
      minPoints
      requiredAchievements
      isActive
      isDefault
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTitleDefinitions = /* GraphQL */ `
  query ListTitleDefinitions(
    $id: ID
    $filter: ModelTitleDefinitionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTitleDefinitions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        type
        name
        description
        color
        rarity
        minAchievements
        minPoints
        requiredAchievements
        isActive
        isDefault
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserAchievement = /* GraphQL */ `
  query GetUserAchievement($id: ID!) {
    getUserAchievement(id: $id) {
      id
      userID
      achievementType
      achievementName
      type
      unlocked
      unlockedAt
      progress
      metadata
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listUserAchievements = /* GraphQL */ `
  query ListUserAchievements(
    $id: ID
    $filter: ModelUserAchievementFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserAchievements(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        achievementType
        achievementName
        type
        unlocked
        unlockedAt
        progress
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAchievementPost = /* GraphQL */ `
  query GetAchievementPost($id: ID!) {
    getAchievementPost(id: $id) {
      id
      userID
      achievementID
      content
      likesCount
      commentsCount
      sharesCount
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listAchievementPosts = /* GraphQL */ `
  query ListAchievementPosts(
    $id: ID
    $filter: ModelAchievementPostFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAchievementPosts(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        achievementID
        content
        likesCount
        commentsCount
        sharesCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAchievementNotification = /* GraphQL */ `
  query GetAchievementNotification($id: ID!) {
    getAchievementNotification(id: $id) {
      id
      userID
      achievementType
      achievementName
      notificationType
      title
      message
      icon
      color
      animationType
      soundEffect
      priority
      isRead
      isDisplayed
      displayDuration
      metadata
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listAchievementNotifications = /* GraphQL */ `
  query ListAchievementNotifications(
    $id: ID
    $filter: ModelAchievementNotificationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAchievementNotifications(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        achievementType
        achievementName
        notificationType
        title
        message
        icon
        color
        animationType
        soundEffect
        priority
        isRead
        isDisplayed
        displayDuration
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserTitleHistory = /* GraphQL */ `
  query GetUserTitleHistory($id: ID!) {
    getUserTitleHistory(id: $id) {
      id
      userID
      previousTitle
      newTitle
      achievementCount
      totalPoints
      reason
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listUserTitleHistories = /* GraphQL */ `
  query ListUserTitleHistories(
    $id: ID
    $filter: ModelUserTitleHistoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserTitleHistories(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        previousTitle
        newTitle
        achievementCount
        totalPoints
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBlockedUser = /* GraphQL */ `
  query GetBlockedUser($id: ID!) {
    getBlockedUser(id: $id) {
      id
      blockerID
      blockedID
      reason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBlockedUsers = /* GraphQL */ `
  query ListBlockedUsers(
    $id: ID
    $filter: ModelBlockedUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listBlockedUsers(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        blockerID
        blockedID
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserReport = /* GraphQL */ `
  query GetUserReport($id: ID!) {
    getUserReport(id: $id) {
      id
      reporterID
      reportedUserID
      messageID
      reason
      description
      category
      status
      adminNotes
      reviewedBy
      reviewedAt
      createdAt
      updatedAt
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      reportedUser {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      message {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listUserReports = /* GraphQL */ `
  query ListUserReports(
    $id: ID
    $filter: ModelUserReportFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserReports(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        reporterID
        reportedUserID
        messageID
        reason
        description
        category
        status
        adminNotes
        reviewedBy
        reviewedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMutedUser = /* GraphQL */ `
  query GetMutedUser($id: ID!) {
    getMutedUser(id: $id) {
      id
      muterID
      mutedUserID
      duration
      expiresAt
      reason
      createdAt
      updatedAt
      muter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      mutedUser {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listMutedUsers = /* GraphQL */ `
  query ListMutedUsers(
    $id: ID
    $filter: ModelMutedUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMutedUsers(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        muterID
        mutedUserID
        duration
        expiresAt
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNewsBookmark = /* GraphQL */ `
  query GetNewsBookmark($id: ID!) {
    getNewsBookmark(id: $id) {
      id
      userID
      newsID
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      news {
        id
        title
        description
        content
        source
        source_url
        author
        published_at
        featured_image
        tmdb_id
        media_type
        category
        tags
        status
        is_featured
        is_breaking
        created_by
        view_count
        bookmark_count
        share_count
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listNewsBookmarks = /* GraphQL */ `
  query ListNewsBookmarks(
    $id: ID
    $filter: ModelNewsBookmarkFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listNewsBookmarks(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        newsID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNewsView = /* GraphQL */ `
  query GetNewsView($id: ID!) {
    getNewsView(id: $id) {
      id
      newsID
      userID
      sessionID
      ipAddress
      userAgent
      createdAt
      news {
        id
        title
        description
        content
        source
        source_url
        author
        published_at
        featured_image
        tmdb_id
        media_type
        category
        tags
        status
        is_featured
        is_breaking
        created_by
        view_count
        bookmark_count
        share_count
        createdAt
        updatedAt
        __typename
      }
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listNewsViews = /* GraphQL */ `
  query ListNewsViews(
    $id: ID
    $filter: ModelNewsViewFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listNewsViews(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        newsID
        userID
        sessionID
        ipAddress
        userAgent
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userPresencesByUserID = /* GraphQL */ `
  query UserPresencesByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserPresenceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userPresencesByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        status
        lastSeen
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const followsByFollowerIDAndCreatedAt = /* GraphQL */ `
  query FollowsByFollowerIDAndCreatedAt(
    $followerID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFollowFilterInput
    $limit: Int
    $nextToken: String
  ) {
    followsByFollowerIDAndCreatedAt(
      followerID: $followerID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        followerID
        followeeID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const followsByFolloweeIDAndCreatedAt = /* GraphQL */ `
  query FollowsByFolloweeIDAndCreatedAt(
    $followeeID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFollowFilterInput
    $limit: Int
    $nextToken: String
  ) {
    followsByFolloweeIDAndCreatedAt(
      followeeID: $followeeID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        followerID
        followeeID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const publicPosts = /* GraphQL */ `
  query PublicPosts(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    publicPosts(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const postsByAuthorIDAndCreatedAt = /* GraphQL */ `
  query PostsByAuthorIDAndCreatedAt(
    $authorID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    postsByAuthorIDAndCreatedAt(
      authorID: $authorID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const commentsByPostIDAndCreatedAt = /* GraphQL */ `
  query CommentsByPostIDAndCreatedAt(
    $postID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentsByPostIDAndCreatedAt(
      postID: $postID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postID
        authorID
        content
        parentID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const commentsByAuthorIDAndCreatedAt = /* GraphQL */ `
  query CommentsByAuthorIDAndCreatedAt(
    $authorID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentsByAuthorIDAndCreatedAt(
      authorID: $authorID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postID
        authorID
        content
        parentID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const likesByPostIDAndUserID = /* GraphQL */ `
  query LikesByPostIDAndUserID(
    $postID: ID!
    $userID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    likesByPostIDAndUserID(
      postID: $postID
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postID
        userID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const likesByUserIDAndPostID = /* GraphQL */ `
  query LikesByUserIDAndPostID(
    $userID: ID!
    $postID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    likesByUserIDAndPostID(
      userID: $userID
      postID: $postID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postID
        userID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sharesByPostIDAndCreatedAt = /* GraphQL */ `
  query SharesByPostIDAndCreatedAt(
    $postID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShareFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sharesByPostIDAndCreatedAt(
      postID: $postID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postID
        userID
        message
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sharesByUserIDAndCreatedAt = /* GraphQL */ `
  query SharesByUserIDAndCreatedAt(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShareFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sharesByUserIDAndCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postID
        userID
        message
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const feedItemsByUserIDAndCreatedAt = /* GraphQL */ `
  query FeedItemsByUserIDAndCreatedAt(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFeedItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    feedItemsByUserIDAndCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        postID
        postOwnerID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const feedItemsByPostIDAndCreatedAt = /* GraphQL */ `
  query FeedItemsByPostIDAndCreatedAt(
    $postID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFeedItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    feedItemsByPostIDAndCreatedAt(
      postID: $postID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        postID
        postOwnerID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userWatchlistsByUserIDAndCreatedAt = /* GraphQL */ `
  query UserWatchlistsByUserIDAndCreatedAt(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserWatchlistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userWatchlistsByUserIDAndCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        name
        description
        isDefault
        isPublic
        itemCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const watchlistItemsByUserIDAndCreatedAt = /* GraphQL */ `
  query WatchlistItemsByUserIDAndCreatedAt(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWatchlistItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    watchlistItemsByUserIDAndCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        watchlistID
        movieID
        showID
        contentType
        status
        priority
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const watchlistItemsByWatchlistIDAndCreatedAt = /* GraphQL */ `
  query WatchlistItemsByWatchlistIDAndCreatedAt(
    $watchlistID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWatchlistItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    watchlistItemsByWatchlistIDAndCreatedAt(
      watchlistID: $watchlistID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        watchlistID
        movieID
        showID
        contentType
        status
        priority
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const watchlistItemsByMovieIDAndCreatedAt = /* GraphQL */ `
  query WatchlistItemsByMovieIDAndCreatedAt(
    $movieID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWatchlistItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    watchlistItemsByMovieIDAndCreatedAt(
      movieID: $movieID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        watchlistID
        movieID
        showID
        contentType
        status
        priority
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const watchlistItemsByShowIDAndCreatedAt = /* GraphQL */ `
  query WatchlistItemsByShowIDAndCreatedAt(
    $showID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWatchlistItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    watchlistItemsByShowIDAndCreatedAt(
      showID: $showID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        watchlistID
        movieID
        showID
        contentType
        status
        priority
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const watchedItemsByUserIDAndCreatedAt = /* GraphQL */ `
  query WatchedItemsByUserIDAndCreatedAt(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWatchedItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    watchedItemsByUserIDAndCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        movieID
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const watchedItemsByMovieIDAndCreatedAt = /* GraphQL */ `
  query WatchedItemsByMovieIDAndCreatedAt(
    $movieID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWatchedItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    watchedItemsByMovieIDAndCreatedAt(
      movieID: $movieID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        movieID
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userMovieInteractionsByUserIDAndCreatedAt = /* GraphQL */ `
  query UserMovieInteractionsByUserIDAndCreatedAt(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserMovieInteractionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userMovieInteractionsByUserIDAndCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        movieID
        watched
        notInterested
        inWatchlist
        isFavorite
        watchCount
        lastWatchedAt
        userRating
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userMovieInteractionsByMovieIDAndCreatedAt = /* GraphQL */ `
  query UserMovieInteractionsByMovieIDAndCreatedAt(
    $movieID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserMovieInteractionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userMovieInteractionsByMovieIDAndCreatedAt(
      movieID: $movieID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        movieID
        watched
        notInterested
        inWatchlist
        isFavorite
        watchCount
        lastWatchedAt
        userRating
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userShowInteractionsByUserIDAndCreatedAt = /* GraphQL */ `
  query UserShowInteractionsByUserIDAndCreatedAt(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserShowInteractionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userShowInteractionsByUserIDAndCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        showID
        watched
        notInterested
        inWatchlist
        isFavorite
        watchCount
        lastWatchedAt
        userRating
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userShowInteractionsByShowIDAndCreatedAt = /* GraphQL */ `
  query UserShowInteractionsByShowIDAndCreatedAt(
    $showID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserShowInteractionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userShowInteractionsByShowIDAndCreatedAt(
      showID: $showID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        showID
        watched
        notInterested
        inWatchlist
        isFavorite
        watchCount
        lastWatchedAt
        userRating
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const notificationsByUserIDAndCreatedAt = /* GraphQL */ `
  query NotificationsByUserIDAndCreatedAt(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByUserIDAndCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        type
        message
        isRead
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const conversationsByUser1IDAndUpdatedAt = /* GraphQL */ `
  query ConversationsByUser1IDAndUpdatedAt(
    $user1ID: ID!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    conversationsByUser1IDAndUpdatedAt(
      user1ID: $user1ID
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const conversationsByUser2IDAndUpdatedAt = /* GraphQL */ `
  query ConversationsByUser2IDAndUpdatedAt(
    $user2ID: ID!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    conversationsByUser2IDAndUpdatedAt(
      user2ID: $user2ID
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const conversationsByCreatedByAndCreatedAt = /* GraphQL */ `
  query ConversationsByCreatedByAndCreatedAt(
    $createdBy: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    conversationsByCreatedByAndCreatedAt(
      createdBy: $createdBy
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const groupParticipantsByConversationIDAndJoinedAt = /* GraphQL */ `
  query GroupParticipantsByConversationIDAndJoinedAt(
    $conversationID: ID!
    $joinedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGroupParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    groupParticipantsByConversationIDAndJoinedAt(
      conversationID: $conversationID
      joinedAt: $joinedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationID
        userID
        role
        joinedAt
        leftAt
        unreadCount
        archived
        archivedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const groupParticipantsByUserIDAndJoinedAt = /* GraphQL */ `
  query GroupParticipantsByUserIDAndJoinedAt(
    $userID: ID!
    $joinedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGroupParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    groupParticipantsByUserIDAndJoinedAt(
      userID: $userID
      joinedAt: $joinedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationID
        userID
        role
        joinedAt
        leftAt
        unreadCount
        archived
        archivedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const groupInvitationsByConversationIDAndCreatedAt = /* GraphQL */ `
  query GroupInvitationsByConversationIDAndCreatedAt(
    $conversationID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGroupInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    groupInvitationsByConversationIDAndCreatedAt(
      conversationID: $conversationID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationID
        invitedUserID
        invitedBy
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const groupInvitationsByInvitedUserIDAndCreatedAt = /* GraphQL */ `
  query GroupInvitationsByInvitedUserIDAndCreatedAt(
    $invitedUserID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGroupInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    groupInvitationsByInvitedUserIDAndCreatedAt(
      invitedUserID: $invitedUserID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationID
        invitedUserID
        invitedBy
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const groupInvitationsByInvitedByAndCreatedAt = /* GraphQL */ `
  query GroupInvitationsByInvitedByAndCreatedAt(
    $invitedBy: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGroupInvitationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    groupInvitationsByInvitedByAndCreatedAt(
      invitedBy: $invitedBy
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationID
        invitedUserID
        invitedBy
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const reviewReportsByReviewIDAndCreatedAt = /* GraphQL */ `
  query ReviewReportsByReviewIDAndCreatedAt(
    $reviewID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelReviewReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reviewReportsByReviewIDAndCreatedAt(
      reviewID: $reviewID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reviewID
        reviewType
        reportedBy
        reason
        description
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const reviewReportsByReportedByAndCreatedAt = /* GraphQL */ `
  query ReviewReportsByReportedByAndCreatedAt(
    $reportedBy: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelReviewReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reviewReportsByReportedByAndCreatedAt(
      reportedBy: $reportedBy
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reviewID
        reviewType
        reportedBy
        reason
        description
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const postReportsByPostIDAndCreatedAt = /* GraphQL */ `
  query PostReportsByPostIDAndCreatedAt(
    $postID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPostReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    postReportsByPostIDAndCreatedAt(
      postID: $postID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postID
        reportedBy
        reason
        description
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const postReportsByReportedByAndCreatedAt = /* GraphQL */ `
  query PostReportsByReportedByAndCreatedAt(
    $reportedBy: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPostReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    postReportsByReportedByAndCreatedAt(
      reportedBy: $reportedBy
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postID
        reportedBy
        reason
        description
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const movieReportsByMovieIDAndCreatedAt = /* GraphQL */ `
  query MovieReportsByMovieIDAndCreatedAt(
    $movieID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMovieReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    movieReportsByMovieIDAndCreatedAt(
      movieID: $movieID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        movieID
        reportedBy
        reason
        description
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const movieReportsByReportedByAndCreatedAt = /* GraphQL */ `
  query MovieReportsByReportedByAndCreatedAt(
    $reportedBy: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMovieReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    movieReportsByReportedByAndCreatedAt(
      reportedBy: $reportedBy
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        movieID
        reportedBy
        reason
        description
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const showReportsByShowIDAndCreatedAt = /* GraphQL */ `
  query ShowReportsByShowIDAndCreatedAt(
    $showID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShowReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    showReportsByShowIDAndCreatedAt(
      showID: $showID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        showID
        reportedBy
        reason
        description
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const showReportsByReportedByAndCreatedAt = /* GraphQL */ `
  query ShowReportsByReportedByAndCreatedAt(
    $reportedBy: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShowReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    showReportsByReportedByAndCreatedAt(
      reportedBy: $reportedBy
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        showID
        reportedBy
        reason
        description
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const messagesByConversationIDAndCreatedAt = /* GraphQL */ `
  query MessagesByConversationIDAndCreatedAt(
    $conversationID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByConversationIDAndCreatedAt(
      conversationID: $conversationID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const messagesBySenderIDAndCreatedAt = /* GraphQL */ `
  query MessagesBySenderIDAndCreatedAt(
    $senderID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesBySenderIDAndCreatedAt(
      senderID: $senderID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const messagesByReceiverIDAndCreatedAt = /* GraphQL */ `
  query MessagesByReceiverIDAndCreatedAt(
    $receiverID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByReceiverIDAndCreatedAt(
      receiverID: $receiverID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const messagesByReplyToMessageIdAndCreatedAt = /* GraphQL */ `
  query MessagesByReplyToMessageIdAndCreatedAt(
    $replyToMessageId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByReplyToMessageIdAndCreatedAt(
      replyToMessageId: $replyToMessageId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userProgressBoostsByUserIDAndCreatedAt = /* GraphQL */ `
  query UserProgressBoostsByUserIDAndCreatedAt(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserProgressBoostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userProgressBoostsByUserIDAndCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        multiplier
        expiresAt
        adminUserID
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const achievementDefinitionsByTypeAndCreatedAt = /* GraphQL */ `
  query AchievementDefinitionsByTypeAndCreatedAt(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAchievementDefinitionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    achievementDefinitionsByTypeAndCreatedAt(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        name
        description
        category
        rarity
        points
        icon
        conditions
        conditionType
        targetValue
        targetField
        contentIds
        genreName
        franchiseId
        isActive
        isRepeatable
        maxProgress
        threshold
        badgeType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const badgeDefinitionsByTypeAndCreatedAt = /* GraphQL */ `
  query BadgeDefinitionsByTypeAndCreatedAt(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBadgeDefinitionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    badgeDefinitionsByTypeAndCreatedAt(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        name
        description
        icon
        color
        rarity
        points
        isActive
        autoAssign
        conditions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const titleDefinitionsByTypeAndCreatedAt = /* GraphQL */ `
  query TitleDefinitionsByTypeAndCreatedAt(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTitleDefinitionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    titleDefinitionsByTypeAndCreatedAt(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        name
        description
        color
        rarity
        minAchievements
        minPoints
        requiredAchievements
        isActive
        isDefault
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userAchievementsByUserIDAndCreatedAt = /* GraphQL */ `
  query UserAchievementsByUserIDAndCreatedAt(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserAchievementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userAchievementsByUserIDAndCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        achievementType
        achievementName
        type
        unlocked
        unlockedAt
        progress
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const achievementPostsByUserIDAndCreatedAt = /* GraphQL */ `
  query AchievementPostsByUserIDAndCreatedAt(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAchievementPostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    achievementPostsByUserIDAndCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        achievementID
        content
        likesCount
        commentsCount
        sharesCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const achievementNotificationsByUserIDAndCreatedAt = /* GraphQL */ `
  query AchievementNotificationsByUserIDAndCreatedAt(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAchievementNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    achievementNotificationsByUserIDAndCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        achievementType
        achievementName
        notificationType
        title
        message
        icon
        color
        animationType
        soundEffect
        priority
        isRead
        isDisplayed
        displayDuration
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userTitleHistoriesByUserIDAndCreatedAt = /* GraphQL */ `
  query UserTitleHistoriesByUserIDAndCreatedAt(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserTitleHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userTitleHistoriesByUserIDAndCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        previousTitle
        newTitle
        achievementCount
        totalPoints
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const blockedUsersByBlockerIDAndCreatedAt = /* GraphQL */ `
  query BlockedUsersByBlockerIDAndCreatedAt(
    $blockerID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBlockedUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    blockedUsersByBlockerIDAndCreatedAt(
      blockerID: $blockerID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        blockerID
        blockedID
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const blockedUsersByBlockedIDAndCreatedAt = /* GraphQL */ `
  query BlockedUsersByBlockedIDAndCreatedAt(
    $blockedID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBlockedUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    blockedUsersByBlockedIDAndCreatedAt(
      blockedID: $blockedID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        blockerID
        blockedID
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userReportsByReporterIDAndCreatedAt = /* GraphQL */ `
  query UserReportsByReporterIDAndCreatedAt(
    $reporterID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userReportsByReporterIDAndCreatedAt(
      reporterID: $reporterID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reporterID
        reportedUserID
        messageID
        reason
        description
        category
        status
        adminNotes
        reviewedBy
        reviewedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userReportsByReportedUserIDAndCreatedAt = /* GraphQL */ `
  query UserReportsByReportedUserIDAndCreatedAt(
    $reportedUserID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userReportsByReportedUserIDAndCreatedAt(
      reportedUserID: $reportedUserID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reporterID
        reportedUserID
        messageID
        reason
        description
        category
        status
        adminNotes
        reviewedBy
        reviewedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userReportsByMessageIDAndCreatedAt = /* GraphQL */ `
  query UserReportsByMessageIDAndCreatedAt(
    $messageID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userReportsByMessageIDAndCreatedAt(
      messageID: $messageID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reporterID
        reportedUserID
        messageID
        reason
        description
        category
        status
        adminNotes
        reviewedBy
        reviewedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mutedUsersByMuterIDAndCreatedAt = /* GraphQL */ `
  query MutedUsersByMuterIDAndCreatedAt(
    $muterID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMutedUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    mutedUsersByMuterIDAndCreatedAt(
      muterID: $muterID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        muterID
        mutedUserID
        duration
        expiresAt
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mutedUsersByMutedUserIDAndCreatedAt = /* GraphQL */ `
  query MutedUsersByMutedUserIDAndCreatedAt(
    $mutedUserID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMutedUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    mutedUsersByMutedUserIDAndCreatedAt(
      mutedUserID: $mutedUserID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        muterID
        mutedUserID
        duration
        expiresAt
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const newsBookmarksByUserIDAndCreatedAt = /* GraphQL */ `
  query NewsBookmarksByUserIDAndCreatedAt(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNewsBookmarkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    newsBookmarksByUserIDAndCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        newsID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const newsBookmarksByNewsIDAndCreatedAt = /* GraphQL */ `
  query NewsBookmarksByNewsIDAndCreatedAt(
    $newsID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNewsBookmarkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    newsBookmarksByNewsIDAndCreatedAt(
      newsID: $newsID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        newsID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const newsViewsByNewsIDAndCreatedAt = /* GraphQL */ `
  query NewsViewsByNewsIDAndCreatedAt(
    $newsID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNewsViewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    newsViewsByNewsIDAndCreatedAt(
      newsID: $newsID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        newsID
        userID
        sessionID
        ipAddress
        userAgent
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const newsViewsByUserIDAndCreatedAt = /* GraphQL */ `
  query NewsViewsByUserIDAndCreatedAt(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNewsViewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    newsViewsByUserIDAndCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        newsID
        userID
        sessionID
        ipAddress
        userAgent
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      username
      identityId
      username_lowercase
      email
      displayName
      displayName_lowercase
      avatar
      coverPhoto
      bio
      website
      location
      role
      followersCount
      followingCount
      postsCount
      watchlistPublic
      interests
      languagePreferences
      verified
      totalAchievementPoints
      titles
      titleOrder
      titleUpdatedAt
      titleSource
      activeBadges
      badgeDisplaySettings
      reviewsCount
      likesReceived
      moviesWatched
      earlyDiscoveries
      loginStreak
      lastLoginDate
      createdAt
      updatedAt
      posts {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      likes {
        nextToken
        __typename
      }
      watched {
        nextToken
        __typename
      }
      followers {
        nextToken
        __typename
      }
      following {
        nextToken
        __typename
      }
      userWatchlists {
        nextToken
        __typename
      }
      userWatchlistItems {
        nextToken
        __typename
      }
      notifications {
        nextToken
        __typename
      }
      movieInteractions {
        nextToken
        __typename
      }
      showInteractions {
        nextToken
        __typename
      }
      sentMessages {
        nextToken
        __typename
      }
      receivedMessages {
        nextToken
        __typename
      }
      conversations {
        nextToken
        __typename
      }
      conversationsAsUser2 {
        nextToken
        __typename
      }
      groupParticipations {
        nextToken
        __typename
      }
      sentInvitations {
        nextToken
        __typename
      }
      receivedInvitations {
        nextToken
        __typename
      }
      postReports {
        nextToken
        __typename
      }
      movieReports {
        nextToken
        __typename
      }
      showReports {
        nextToken
        __typename
      }
      movieReviews {
        nextToken
        __typename
      }
      showReviews {
        nextToken
        __typename
      }
      reviewReports {
        nextToken
        __typename
      }
      reviewLikes {
        nextToken
        __typename
      }
      shares {
        nextToken
        __typename
      }
      bookmarks {
        nextToken
        __typename
      }
      achievements {
        nextToken
        __typename
      }
      badges {
        nextToken
        __typename
      }
      achievementPosts {
        nextToken
        __typename
      }
      progressBoosts {
        nextToken
        __typename
      }
      achievementNotifications {
        nextToken
        __typename
      }
      titleHistory {
        nextToken
        __typename
      }
      blockedUsers {
        nextToken
        __typename
      }
      blockedByUsers {
        nextToken
        __typename
      }
      reportsMade {
        nextToken
        __typename
      }
      reportsReceived {
        nextToken
        __typename
      }
      mutedUsers {
        nextToken
        __typename
      }
      mutedByUsers {
        nextToken
        __typename
      }
      newsBookmarks {
        nextToken
        __typename
      }
      newsViews {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $id: ID
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUsers(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userByUsername = /* GraphQL */ `
  query UserByUsername(
    $username: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByUsername(
      username: $username
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBookmark = /* GraphQL */ `
  query GetBookmark($id: ID!) {
    getBookmark(id: $id) {
      id
      postID
      reviewID
      userID
      contentType
      reviewType
      notes
      tags
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listBookmarks = /* GraphQL */ `
  query ListBookmarks(
    $id: ID
    $filter: ModelBookmarkFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listBookmarks(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        postID
        reviewID
        userID
        contentType
        reviewType
        notes
        tags
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const bookmarksByPostIDAndCreatedAt = /* GraphQL */ `
  query BookmarksByPostIDAndCreatedAt(
    $postID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBookmarkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookmarksByPostIDAndCreatedAt(
      postID: $postID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postID
        reviewID
        userID
        contentType
        reviewType
        notes
        tags
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const bookmarksByReviewIDAndCreatedAt = /* GraphQL */ `
  query BookmarksByReviewIDAndCreatedAt(
    $reviewID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBookmarkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookmarksByReviewIDAndCreatedAt(
      reviewID: $reviewID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postID
        reviewID
        userID
        contentType
        reviewType
        notes
        tags
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const bookmarksByUserIDAndCreatedAt = /* GraphQL */ `
  query BookmarksByUserIDAndCreatedAt(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBookmarkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookmarksByUserIDAndCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        postID
        reviewID
        userID
        contentType
        reviewType
        notes
        tags
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMovie = /* GraphQL */ `
  query GetMovie($id: ID!) {
    getMovie(id: $id) {
      id
      name
      poster
      content_type
      genre
      hero
      heroine
      director
      music
      screenplay
      editor
      cameraman
      language
      summary
      rating
      hypeRating
      hypeScore
      hypeBreakdown
      totalInteractions
      viewCount
      watchlistCount
      watchedCount
      reviewCount
      shareCount
      ottClickCount
      reviewLikeCount
      release_date
      ott_release_date
      popularity
      trending
      created_at
      updated_at
      watchlistItems {
        nextToken
        __typename
      }
      watched {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMovies = /* GraphQL */ `
  query ListMovies(
    $id: ID
    $filter: ModelMovieFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMovies(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const moviesByContent_typeAndRelease_date = /* GraphQL */ `
  query MoviesByContent_typeAndRelease_date(
    $content_type: String!
    $release_date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMovieFilterInput
    $limit: Int
    $nextToken: String
  ) {
    moviesByContent_typeAndRelease_date(
      content_type: $content_type
      release_date: $release_date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const moviesByRelease_dateAndRating = /* GraphQL */ `
  query MoviesByRelease_dateAndRating(
    $release_date: AWSDateTime!
    $rating: ModelFloatKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMovieFilterInput
    $limit: Int
    $nextToken: String
  ) {
    moviesByRelease_dateAndRating(
      release_date: $release_date
      rating: $rating
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getShow = /* GraphQL */ `
  query GetShow($id: ID!) {
    getShow(id: $id) {
      id
      name
      poster
      content_type
      genre
      hero
      heroine
      director
      music
      screenplay
      editor
      cameraman
      language
      summary
      rating
      hypeRating
      hypeScore
      hypeBreakdown
      totalInteractions
      viewCount
      watchlistCount
      watchedCount
      reviewCount
      shareCount
      ottClickCount
      reviewLikeCount
      release_date
      ott_release_date
      popularity
      trending
      created_at
      updated_at
      interactions {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      watchlistItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listShows = /* GraphQL */ `
  query ListShows(
    $id: ID
    $filter: ModelShowFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listShows(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const showsByContent_typeAndRelease_date = /* GraphQL */ `
  query ShowsByContent_typeAndRelease_date(
    $content_type: String!
    $release_date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShowFilterInput
    $limit: Int
    $nextToken: String
  ) {
    showsByContent_typeAndRelease_date(
      content_type: $content_type
      release_date: $release_date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const showsByRelease_dateAndRating = /* GraphQL */ `
  query ShowsByRelease_dateAndRating(
    $release_date: AWSDateTime!
    $rating: ModelFloatKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShowFilterInput
    $limit: Int
    $nextToken: String
  ) {
    showsByRelease_dateAndRating(
      release_date: $release_date
      rating: $rating
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMovieReview = /* GraphQL */ `
  query GetMovieReview($id: ID!) {
    getMovieReview(id: $id) {
      id
      movieID
      authorID
      rating
      review
      ratingSystem
      emoji
      status
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      reports {
        nextToken
        __typename
      }
      likesCount
      __typename
    }
  }
`;
export const listMovieReviews = /* GraphQL */ `
  query ListMovieReviews(
    $id: ID
    $filter: ModelMovieReviewFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMovieReviews(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        movieID
        authorID
        rating
        review
        ratingSystem
        emoji
        status
        createdAt
        updatedAt
        likesCount
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const movieReviewsByMovieIDAndCreatedAt = /* GraphQL */ `
  query MovieReviewsByMovieIDAndCreatedAt(
    $movieID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMovieReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    movieReviewsByMovieIDAndCreatedAt(
      movieID: $movieID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        movieID
        authorID
        rating
        review
        ratingSystem
        emoji
        status
        createdAt
        updatedAt
        likesCount
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const movieReviewsByAuthorIDAndCreatedAt = /* GraphQL */ `
  query MovieReviewsByAuthorIDAndCreatedAt(
    $authorID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMovieReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    movieReviewsByAuthorIDAndCreatedAt(
      authorID: $authorID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        movieID
        authorID
        rating
        review
        ratingSystem
        emoji
        status
        createdAt
        updatedAt
        likesCount
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getShowReview = /* GraphQL */ `
  query GetShowReview($id: ID!) {
    getShowReview(id: $id) {
      id
      showID
      authorID
      rating
      review
      ratingSystem
      emoji
      status
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      reports {
        nextToken
        __typename
      }
      likesCount
      __typename
    }
  }
`;
export const listShowReviews = /* GraphQL */ `
  query ListShowReviews(
    $id: ID
    $filter: ModelShowReviewFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listShowReviews(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        showID
        authorID
        rating
        review
        ratingSystem
        emoji
        status
        createdAt
        updatedAt
        likesCount
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const showReviewsByShowIDAndCreatedAt = /* GraphQL */ `
  query ShowReviewsByShowIDAndCreatedAt(
    $showID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShowReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    showReviewsByShowIDAndCreatedAt(
      showID: $showID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        showID
        authorID
        rating
        review
        ratingSystem
        emoji
        status
        createdAt
        updatedAt
        likesCount
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const showReviewsByAuthorIDAndCreatedAt = /* GraphQL */ `
  query ShowReviewsByAuthorIDAndCreatedAt(
    $authorID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShowReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    showReviewsByAuthorIDAndCreatedAt(
      authorID: $authorID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        showID
        authorID
        rating
        review
        ratingSystem
        emoji
        status
        createdAt
        updatedAt
        likesCount
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getReviewLike = /* GraphQL */ `
  query GetReviewLike($id: ID!) {
    getReviewLike(id: $id) {
      id
      reviewID
      userID
      reviewType
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listReviewLikes = /* GraphQL */ `
  query ListReviewLikes(
    $id: ID
    $filter: ModelReviewLikeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listReviewLikes(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        reviewID
        userID
        reviewType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const reviewLikesByReviewIDAndUserID = /* GraphQL */ `
  query ReviewLikesByReviewIDAndUserID(
    $reviewID: ID!
    $userID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelReviewLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reviewLikesByReviewIDAndUserID(
      reviewID: $reviewID
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reviewID
        userID
        reviewType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const reviewLikesByUserIDAndReviewID = /* GraphQL */ `
  query ReviewLikesByUserIDAndReviewID(
    $userID: ID!
    $reviewID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelReviewLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reviewLikesByUserIDAndReviewID(
      userID: $userID
      reviewID: $reviewID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reviewID
        userID
        reviewType
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInteractionEvent = /* GraphQL */ `
  query GetInteractionEvent($id: ID!) {
    getInteractionEvent(id: $id) {
      id
      userID
      movieID
      showID
      contentType
      action
      sessionID
      deviceType
      platform
      duration
      metadata
      timestamp
      createdAt
      isAnonymous
      ipAddress
      userAgent
      updatedAt
      __typename
    }
  }
`;
export const listInteractionEvents = /* GraphQL */ `
  query ListInteractionEvents(
    $id: ID
    $filter: ModelInteractionEventFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listInteractionEvents(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        movieID
        showID
        contentType
        action
        sessionID
        deviceType
        platform
        duration
        metadata
        timestamp
        createdAt
        isAnonymous
        ipAddress
        userAgent
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const interactionEventsByUserIDAndTimestamp = /* GraphQL */ `
  query InteractionEventsByUserIDAndTimestamp(
    $userID: ID!
    $timestamp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInteractionEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    interactionEventsByUserIDAndTimestamp(
      userID: $userID
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        movieID
        showID
        contentType
        action
        sessionID
        deviceType
        platform
        duration
        metadata
        timestamp
        createdAt
        isAnonymous
        ipAddress
        userAgent
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const interactionEventsByMovieIDAndTimestamp = /* GraphQL */ `
  query InteractionEventsByMovieIDAndTimestamp(
    $movieID: ID!
    $timestamp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInteractionEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    interactionEventsByMovieIDAndTimestamp(
      movieID: $movieID
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        movieID
        showID
        contentType
        action
        sessionID
        deviceType
        platform
        duration
        metadata
        timestamp
        createdAt
        isAnonymous
        ipAddress
        userAgent
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const interactionEventsByShowIDAndTimestamp = /* GraphQL */ `
  query InteractionEventsByShowIDAndTimestamp(
    $showID: ID!
    $timestamp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInteractionEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    interactionEventsByShowIDAndTimestamp(
      showID: $showID
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        movieID
        showID
        contentType
        action
        sessionID
        deviceType
        platform
        duration
        metadata
        timestamp
        createdAt
        isAnonymous
        ipAddress
        userAgent
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserBadge = /* GraphQL */ `
  query GetUserBadge($id: ID!) {
    getUserBadge(id: $id) {
      id
      userID
      badgeType
      earnedAt
      metadata
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserBadges = /* GraphQL */ `
  query ListUserBadges(
    $id: ID
    $filter: ModelUserBadgeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserBadges(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userID
        badgeType
        earnedAt
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userBadgesByUserIDAndEarnedAt = /* GraphQL */ `
  query UserBadgesByUserIDAndEarnedAt(
    $userID: ID!
    $earnedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserBadgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userBadgesByUserIDAndEarnedAt(
      userID: $userID
      earnedAt: $earnedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        badgeType
        earnedAt
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNews = /* GraphQL */ `
  query GetNews($id: ID!) {
    getNews(id: $id) {
      id
      title
      description
      content
      source
      source_url
      author
      published_at
      featured_image
      tmdb_id
      media_type
      category
      tags
      status
      is_featured
      is_breaking
      created_by
      view_count
      bookmark_count
      share_count
      createdAt
      updatedAt
      bookmarks {
        nextToken
        __typename
      }
      views {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listNews = /* GraphQL */ `
  query ListNews(
    $id: ID
    $filter: ModelNewsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listNews(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        title
        description
        content
        source
        source_url
        author
        published_at
        featured_image
        tmdb_id
        media_type
        category
        tags
        status
        is_featured
        is_breaking
        created_by
        view_count
        bookmark_count
        share_count
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const newsByTmdb_idAndPublished_at = /* GraphQL */ `
  query NewsByTmdb_idAndPublished_at(
    $tmdb_id: String!
    $published_at: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNewsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    newsByTmdb_idAndPublished_at(
      tmdb_id: $tmdb_id
      published_at: $published_at
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        content
        source
        source_url
        author
        published_at
        featured_image
        tmdb_id
        media_type
        category
        tags
        status
        is_featured
        is_breaking
        created_by
        view_count
        bookmark_count
        share_count
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const newsByCategoryAndPublished_at = /* GraphQL */ `
  query NewsByCategoryAndPublished_at(
    $category: String!
    $published_at: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNewsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    newsByCategoryAndPublished_at(
      category: $category
      published_at: $published_at
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        content
        source
        source_url
        author
        published_at
        featured_image
        tmdb_id
        media_type
        category
        tags
        status
        is_featured
        is_breaking
        created_by
        view_count
        bookmark_count
        share_count
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const newsByStatusAndPublished_at = /* GraphQL */ `
  query NewsByStatusAndPublished_at(
    $status: String!
    $published_at: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNewsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    newsByStatusAndPublished_at(
      status: $status
      published_at: $published_at
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        content
        source
        source_url
        author
        published_at
        featured_image
        tmdb_id
        media_type
        category
        tags
        status
        is_featured
        is_breaking
        created_by
        view_count
        bookmark_count
        share_count
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listMoviesByCategory = /* GraphQL */ `
  query ListMoviesByCategory(
    $category: String!
    $limit: Int
    $nextToken: String
  ) {
    listMoviesByCategory(
      category: $category
      limit: $limit
      nextToken: $nextToken
    ) {
      id
      name
      poster
      content_type
      genre
      hero
      heroine
      director
      music
      screenplay
      editor
      cameraman
      language
      summary
      rating
      hypeRating
      hypeScore
      hypeBreakdown
      totalInteractions
      viewCount
      watchlistCount
      watchedCount
      reviewCount
      shareCount
      ottClickCount
      reviewLikeCount
      release_date
      ott_release_date
      popularity
      trending
      created_at
      updated_at
      watchlistItems {
        nextToken
        __typename
      }
      watched {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const searchMovies = /* GraphQL */ `
  query SearchMovies($query: String!, $limit: Int) {
    searchMovies(query: $query, limit: $limit) {
      id
      name
      poster
      content_type
      genre
      hero
      heroine
      director
      music
      screenplay
      editor
      cameraman
      language
      summary
      rating
      hypeRating
      hypeScore
      hypeBreakdown
      totalInteractions
      viewCount
      watchlistCount
      watchedCount
      reviewCount
      shareCount
      ottClickCount
      reviewLikeCount
      release_date
      ott_release_date
      popularity
      trending
      created_at
      updated_at
      watchlistItems {
        nextToken
        __typename
      }
      watched {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const getTrendingMovies = /* GraphQL */ `
  query GetTrendingMovies($limit: Int) {
    getTrendingMovies(limit: $limit) {
      id
      name
      poster
      content_type
      genre
      hero
      heroine
      director
      music
      screenplay
      editor
      cameraman
      language
      summary
      rating
      hypeRating
      hypeScore
      hypeBreakdown
      totalInteractions
      viewCount
      watchlistCount
      watchedCount
      reviewCount
      shareCount
      ottClickCount
      reviewLikeCount
      release_date
      ott_release_date
      popularity
      trending
      created_at
      updated_at
      watchlistItems {
        nextToken
        __typename
      }
      watched {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const getMoviesByReleaseType = /* GraphQL */ `
  query GetMoviesByReleaseType($releaseType: String!, $limit: Int) {
    getMoviesByReleaseType(releaseType: $releaseType, limit: $limit) {
      id
      name
      poster
      content_type
      genre
      hero
      heroine
      director
      music
      screenplay
      editor
      cameraman
      language
      summary
      rating
      hypeRating
      hypeScore
      hypeBreakdown
      totalInteractions
      viewCount
      watchlistCount
      watchedCount
      reviewCount
      shareCount
      ottClickCount
      reviewLikeCount
      release_date
      ott_release_date
      popularity
      trending
      created_at
      updated_at
      watchlistItems {
        nextToken
        __typename
      }
      watched {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const getPopularMovies = /* GraphQL */ `
  query GetPopularMovies($limit: Int) {
    getPopularMovies(limit: $limit) {
      id
      name
      poster
      content_type
      genre
      hero
      heroine
      director
      music
      screenplay
      editor
      cameraman
      language
      summary
      rating
      hypeRating
      hypeScore
      hypeBreakdown
      totalInteractions
      viewCount
      watchlistCount
      watchedCount
      reviewCount
      shareCount
      ottClickCount
      reviewLikeCount
      release_date
      ott_release_date
      popularity
      trending
      created_at
      updated_at
      watchlistItems {
        nextToken
        __typename
      }
      watched {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const getAchievementLeaderboard = /* GraphQL */ `
  query GetAchievementLeaderboard($input: GetAchievementLeaderboardInput!) {
    getAchievementLeaderboard(input: $input) {
      success
      leaderboard {
        rank
        userId
        username
        displayName
        avatar
        title
        achievementCount
        totalPoints
        badgeCount
        latestUnlock
        __typename
      }
      totalEntries
      timeframe
      achievementType
      generatedAt
      __typename
    }
  }
`;
export const getNewsByCategory = /* GraphQL */ `
  query GetNewsByCategory($category: String!, $limit: Int, $nextToken: String) {
    getNewsByCategory(
      category: $category
      limit: $limit
      nextToken: $nextToken
    ) {
      id
      title
      description
      content
      source
      source_url
      author
      published_at
      featured_image
      tmdb_id
      media_type
      category
      tags
      status
      is_featured
      is_breaking
      created_by
      view_count
      bookmark_count
      share_count
      createdAt
      updatedAt
      bookmarks {
        nextToken
        __typename
      }
      views {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const getNewsByMovie = /* GraphQL */ `
  query GetNewsByMovie($tmdbId: String!, $limit: Int, $nextToken: String) {
    getNewsByMovie(tmdbId: $tmdbId, limit: $limit, nextToken: $nextToken) {
      id
      title
      description
      content
      source
      source_url
      author
      published_at
      featured_image
      tmdb_id
      media_type
      category
      tags
      status
      is_featured
      is_breaking
      created_by
      view_count
      bookmark_count
      share_count
      createdAt
      updatedAt
      bookmarks {
        nextToken
        __typename
      }
      views {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const getFeaturedNews = /* GraphQL */ `
  query GetFeaturedNews($limit: Int, $nextToken: String) {
    getFeaturedNews(limit: $limit, nextToken: $nextToken) {
      id
      title
      description
      content
      source
      source_url
      author
      published_at
      featured_image
      tmdb_id
      media_type
      category
      tags
      status
      is_featured
      is_breaking
      created_by
      view_count
      bookmark_count
      share_count
      createdAt
      updatedAt
      bookmarks {
        nextToken
        __typename
      }
      views {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
